// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__WJApV","item_text":"TodoItem_item_text__jTL-S","done":"TodoItem_done__kD0iW","button_row":"TodoItem_button_row__Vb7LM"};